import { render } from "./PayProvidersView.vue?vue&type=template&id=49bb957f"
import script from "./PayProvidersView.vue?vue&type=script&lang=js"
export * from "./PayProvidersView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__